/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import IconButton from '@/components/buttons/IconButton'
import { Button, Flex } from '@chakra-ui/react'
import Styles from './styles.module.sass'
import { SAM_DETAIL_METADATA, AI_METADATA_LABEL, AI_METADATA_CREATE } from '@/configs/strings/sams-list'
import { useResponsive } from '@/hooks/useResponsive'
import { GO_TO_MARKET } from '@/configs/strings/sams'
import { contentOptions } from '../../handlers'

const ButtonBar = ({
  onOptionChange,
  currentOption
}) => {
  const { flexDirection, flexGap } = useResponsive()
  const selectedColor = '#1C2646'
  return (
    <Flex
      flexDirection={flexDirection}
      gap={flexGap}
      className={`${Styles.buttonBar} mb-sm mt-6`}
    >
      <Button
        onClick={() => onOptionChange(contentOptions.listSams)}
        bg={currentOption === contentOptions.listSams ? selectedColor : null}
        className="uppercase"
      >
        {GO_TO_MARKET}
      </Button>
      <IconButton
        icon="FaRegListAlt"
        label={SAM_DETAIL_METADATA}
        onClick={() => onOptionChange(contentOptions.metadata)}
        bg={currentOption === contentOptions.metadata ? selectedColor : null}
      />
      <IconButton
        icon="FaRegListAlt"
        label={AI_METADATA_LABEL}
        onClick={() => onOptionChange(contentOptions.aiMetadata)}
        bg={currentOption === contentOptions.aiMetadata ? selectedColor : null}
      />
      <Button
        onClick={() => onOptionChange(contentOptions.revenueBreakdown)}
        bg={currentOption === contentOptions.revenueBreakdown ? selectedColor : null}
        className="uppercase"
      >
        Revenue Breakdown
      </Button>
      <Button
        onClick={() => onOptionChange(contentOptions.addAiMetadata)}
        bg={currentOption === contentOptions.addAiMetadata ? selectedColor : null}
        className="uppercase"
      >
        { AI_METADATA_CREATE }
      </Button>
    </Flex>
  )
}

export default ButtonBar
